import { createTheme } from "@mui/material/styles";

const theme = createTheme(
    {
        typography: {
            fontFamily: ['IBM Plex Sans', 'sans-serif'].join(','),
            fontSize: 12,
            body2: {
                fontWeight: 300,
            }
        },
        components: {
            MuiAlert: {
                styleOverrides: {
                    filledSuccess: {
                        backgroundColor: '#8a8d32',
                        color: 'white'
                    },
                    filledError: {
                        backgroundColor: '#7d1327',
                        color: 'white'
                    },
                    filledWarning: {
                        backgroundColor: '#db8925',
                        color: 'white'
                    },
                    filledInfo: {
                        backgroundColor: '#7bafd4',
                        color: 'black'
                    }
                }
            },

        }
    },

)

export default theme;